export const ru = {
  seeAll: 'Посмотреть все',
  viewMore: 'Показать еще',
};
